<!-- 联系表单组件 -->
<template>
  <template v-if="!props.bare">
    <v-card class="contact-form-card">
      <v-card-text class="pa-8">
        <h3 class="form-title mb-6">{{ t('footer.inquiry') }}</h3>
        <v-form ref="formRef" @submit.prevent="submitContactForm" v-model="formValid">
          <v-text-field
            v-model="contactForm.name"
            :label="t('footer.inquiryForm.name')"
            variant="outlined"
            density="compact"
            class="mb-2 form-field"
            hide-details
            :rules="nameRules"
          ></v-text-field>
          <v-text-field
            v-model="contactForm.phone"
            :label="t('footer.inquiryForm.tel')"
            variant="outlined"
            density="compact"
            class="mb-2 form-field"
            hide-details
            :rules="phoneRules"
          ></v-text-field>
          <v-text-field
            v-model="contactForm.email"
            :label="t('footer.inquiryForm.email')"
            variant="outlined"
            density="compact"
            class="mb-2 form-field"
            hide-details
            :rules="emailRules"
          ></v-text-field>
          <v-textarea
            v-model="contactForm.message"
            :label="t('footer.inquiryForm.message')"
            variant="outlined"
            density="compact"
            class="mb-2 form-field"
            hide-details
          ></v-textarea>
          <v-btn
            type="submit"
            variant="elevated"
            block
            class="mt-5 send-btn"
            color="primary"
            :loading="submitting"
            :disabled="!formValid"
          >
            {{ t('footer.inquiryForm.sendMessage') }}
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </template>
  <template v-else>
    <div class="contact-form-bare">
      <div>
        <h3 v-if="props.showTitle" class="form-title mb-4">{{ t('footer.inquiry') }}</h3>
        <v-form ref="formRef" @submit.prevent="submitContactForm" v-model="formValid">
          <v-text-field
            v-model="contactForm.name"
            :label="t('footer.inquiryForm.name')"
            variant="outlined"
            density="compact"
            class="mb-2 form-field"
            hide-details
            :rules="nameRules"
          ></v-text-field>
          <v-text-field
            v-model="contactForm.phone"
            :label="t('footer.inquiryForm.tel')"
            variant="outlined"
            density="compact"
            class="mb-2 form-field"
            hide-details
            :rules="phoneRules"
          ></v-text-field>
          <v-text-field
            v-model="contactForm.email"
            :label="t('footer.inquiryForm.email')"
            variant="outlined"
            density="compact"
            class="mb-2 form-field"
            hide-details
            :rules="emailRules"
          ></v-text-field>
          <v-textarea
            v-model="contactForm.message"
            :label="t('footer.inquiryForm.message')"
            variant="outlined"
            density="compact"
            class="mb-2 form-field"
            hide-details
          ></v-textarea>
          <v-btn
            type="submit"
            variant="elevated"
            block
            class="mt-4 send-btn"
            color="primary"
            :loading="submitting"
            :disabled="!formValid"
          >
            {{ t('footer.inquiryForm.sendMessage') }}
          </v-btn>
        </v-form>
      </div>
    </div>
  </template>
  <v-snackbar v-model="snackbar" :timeout="2500" :color="snackbarColor" location="top">
    {{ snackbarText }}
  </v-snackbar>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
interface Props {
  bare?: boolean
  showTitle?: boolean,
  product_name?: string
}

const props = withDefaults(defineProps<Props>(), {
  bare: false,
  showTitle: true,
  product_name:""
})

const { t } = useI18n({
  inheritLocale: true,
  useScope: 'global'
})

const formValid = ref(false)
const submitting = ref(false)
const formRef = ref()
const snackbar = ref(false)
const snackbarText = ref('提交成功')
const snackbarColor = ref('success')

const submitUrl="https://fhtd.tsanyi.top/api/submit"


const contactForm = ref({
"name": "",
  "email": "",
  "message": "",
  "phone": "",
  "product_name": ""
})

const required = (v: string) => (!!v && String(v).trim().length > 0) || t('common.required') || 'Required'
const emailFormat = (v: string) => /.+@.+\..+/.test(String(v)) || t('common.invalidEmail') || 'Invalid email'

const nameRules = [required]
const phoneRules = [required]
const emailRules = [required, emailFormat]

// 提交表单
const submitContactForm = async () => {
  submitting.value = true
  try {
    // 先校验
    if (formRef.value?.validate) {
      const result = await formRef.value.validate()
      // Vuetify v3 validate() 返回 { valid: boolean }
      if (result && result.valid === false) {
        submitting.value = false
        return
      }
    } else if (!formValid.value) {
      submitting.value = false
      return
    }
    
    // 调用接口提交数据
    const response = await fetch(submitUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        name: contactForm.value.name,
        email: contactForm.value.email,
        message: contactForm.value.message,
        phone: contactForm.value.phone,
        product_name: props.product_name
      })
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const data = await response.json()
    console.log('提交结果:', data)
    
    // 检查业务状态码
    if (data.errCode === 0) {
      // 成功提示
      console.log('✅ 成功！')
      console.log('留言ID:', data.data?.id)
      console.log('地理位置:', data.data?.location)
      
      snackbarColor.value = 'success'
      snackbarText.value = t('footer.inquiryForm.success') || '提交成功'
      snackbar.value = true
      
      // 重置表单 - 先重置验证状态，再清空数据
      if (formRef.value?.reset) {
        formRef.value.reset()
      } else {
        // 降级方案：先清空数据再重置验证
        contactForm.value = {
          "name": "",
          "email": "",
          "message": "",
          "phone": "",
          "product_name": ""
        }
        if (formRef.value?.resetValidation) {
          formRef.value.resetValidation()
        }
      }
    } else {
      // 业务失败
      console.log('❌ 失败:', data.errMsg)
      snackbarColor.value = 'error'
      snackbarText.value = data.errMsg || t('footer.inquiryForm.error') || '提交失败，请稍后重试'
      snackbar.value = true
    }
  } catch (error) {
    console.error('Form submission error:', error)
    // 错误提示
    snackbarColor.value = 'error'
    snackbarText.value = t('footer.inquiryForm.error') || '提交失败，请稍后重试'
    snackbar.value = true
  } finally {
    submitting.value = false
  }
}
</script>

<style scoped>
.contact-form-card {
  height: 100%;
  background: #F5F7FA;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.contact-form-bare {
  background: transparent;
}

.form-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 2rem;
  text-transform: uppercase;
}

/* 修复表单字段的样式 */
.form-field {
  --v-theme-surface: rgba(255, 255, 255, 0.1);
}

:deep(.v-field) {
  border-radius: 8px;
}

:deep(.v-field__outline) {
  color: rgba(0, 0, 0, 0.15);
}

:deep(.v-field--focused .v-field__outline) {
  color: rgb(var(--v-theme-primary));
}

:deep(.v-field__input) {
  padding: 12px 16px;
  font-size: 0.95rem;
}

.send-btn {
  border-radius: 8px;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0.5px;
  height: 48px;
}

.send-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(var(--v-theme-primary), 0.3);
}

.map-section {
  margin-top: 2rem;
}

.map-placeholder {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
}

.map-image {
  border-radius: 12px;
}

.map-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.map-btn {
  backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.9) !important;
  color: rgb(var(--v-theme-primary)) !important;
}

.map-btn:hover {
  background: white !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
</style> 